/** Paramètres de la ferme (GET/PUT /api/parametres). Toutes les valeurs ont un défaut côté serveur. */
export interface ParametresFerme {
  raisonSociale?: string;
  formeJuridique?: string;
  capitalSocial?: string;
  rccm?: string;
  siteWeb?: string;
  banqueNom?: string;
  banqueAgence?: string;
  banqueCompte?: string;
  banqueTitulaire?: string;

  prefixeFacture: string;
  prefixeProforma: string;
  prefixeAvoir: string;
  prefixeRecu: string;
  formatNumero: string;
  tvaApplicable: boolean;
  tauxTva: number;
  mentionTva: string;
  delaiEcheanceDefaut: number;
  validiteProformaJours: number;
  conditionsFacture: string;
  conditionsProforma: string;
  piedDePage?: string;
  modesPaiementAcceptes: string[];
  signatureObjet?: string;
  /** Logo téléversé (prioritaire) ; l'ancien logo de la fiche ferme sert de repli côté serveur */
  logoObjet?: string;
  /** Calculé par le serveur : un logo existe (téléversé ou ancien logo de la fiche ferme) */
  logoDisponible?: boolean;
  cachetObjet?: string;
  signataire?: string;
  modelePdf: 'OFFICIEL' | 'CLASSIQUE';
  couleurPdf: string;

  proposerFactureApresVente: { [module: string]: boolean };
  archiverPdfGed: boolean;
  genererRecu: boolean;
  ouvrirPartageApresEmission: boolean;
  canalPartageDefaut: string;
  messageFacture: string;
  messageRecu: string;
  messageRelance: string;
  messageRapport: string;
  liensPublicsActifs: boolean;
  lienPublicExpirationJours: number;

  modePaiementDefaut: string;
  creditAutorise: boolean;
  /** Le Personnel ne voit plus les montants (totaux, prix, coûts, transactions des autres) ; il garde la saisie */
  masquerMontantsPersonnel?: boolean;
  /** Saisies de production du Personnel retenues jusqu'à validation */
  validationSaisiesPersonnel?: boolean;
  joursAvantRelance: number;
  verrouillageMois: boolean;
  moisClotures: string[];
  creerRevenuAEmission: boolean;
  soldesInitiauxParMode: { [mode: string]: number };

  impactAgeJeuneMax?: number;
  impactBudgetAnnuel?: { [annee: string]: number };
  impactMotsClesRemuneration?: string[];
  messageRapportImpact?: string;
  updatedAt?: string;
  updatedBy?: string;
}

/** Modes de paiement proposés partout (ordre d'affichage) */
export const MODES_PAIEMENT = ['Wave', 'Espèces', 'Orange Money', 'Free Money', 'Virement bancaire', 'Chèque'];

/** Libellés courts pour les puces */
export const MODES_PAIEMENT_COURTS: { [mode: string]: string } = {
  'Wave': 'Wave', 'Espèces': 'Espèces', 'Orange Money': 'OM', 'Free Money': 'Free', 'Virement bancaire': 'Virement', 'Chèque': 'Chèque'
};

/** Variables utilisables dans les modèles de messages */
export const VARIABLES_MESSAGES = [
  { cle: '{client}', aide: 'nom du client' },
  { cle: '{ferme}', aide: 'nom de la ferme' },
  { cle: '{document}', aide: 'facture, proforma, avoir' },
  { cle: '{numero}', aide: 'numéro du document' },
  { cle: '{montant}', aide: 'montant (FCFA)' },
  { cle: '{reste}', aide: 'reste à payer' },
  { cle: '{echeance}', aide: 'date d\'échéance' },
  { cle: '{echeance_phrase}', aide: '« , à régler avant le … »' },
  { cle: '{date}', aide: 'date du paiement' },
  { cle: '{mode}', aide: 'mode de paiement' },
  { cle: '{objet}', aide: 'objet du paiement' },
  { cle: '{reste_phrase}', aide: '« Reste dû : … »' },
  { cle: '{lignes}', aide: 'liste des impayés' },
  { cle: '{lien}', aide: 'lien vers le document' },
  { cle: '{periode}', aide: 'période du rapport' },
  { cle: '{telephone_ferme}', aide: 'téléphone de la ferme' },
];
